module.exports = __webpack_public_path__ + "img/bra.4fae5016.svg";